import React, { useState, useEffect } from "react";
import { Menu, Layout, Divider } from "antd";
import { css } from "@emotion/react";
import { Link, useNavigation, useNavigate } from "react-router-dom";
import favicon from "/favicon.png";
import { findMenuItem, processItem } from "../FormilyPreview/util";

const cssLayoutHeader = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: 0,
});
const cssLayoutHeaderLeft = css({
  fontSize: 20,
  color: "#fff",
  padding: "0 15px",
  display: "flex",
  alignItems: "center",
  width: '300px',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});
const cssLayoutHeaderCenter = css({
  fontSize: 14,
  fontWeight: "bold",
  color: "#fff",
  padding: "0 15px",
  display: "flex",
  justifyContent: "center",
  width: '400px',
  wordWrap: '',
  alignItems: "center",
  textOverflow: "ellipsis",
  overflow: 'hidden',
  wordBreak: 'break-all',
  whiteSpace: 'nowrap',
  gap: 12,
});
const cssLayoutHeaderRight = css({
  color: "#fff",
  flexGrow: "1",
  flexShrink: "0",
  flexBasis: 0,
  display: 'flex',
  justifyContent: 'end',
  maxWidth: 'calc(100% - 700px)',
  gap: 12,
//   gap: 12,
});
const cssLink = css({
  fontWeight: "bold",
  color: "#fff",
  display: "flex",
  alignItems: "center",
});
const cssLogo = css({
  height: 22,
  marginRight: 8,
});
const cssDivider = css({
  borderColor: "#fff",
});


const Header = ({ current, menuData, handleMenuChange }) => {
  const items = menuData.map(processItem)
  
  const handleMenuClick = (e) => {
    const targetItem = findMenuItem(items, e.key)
    const customData = targetItem?.custom;
    handleMenuChange(e.key, {
      key: e.key,
      ...customData
    })
  };

  return (
    <Layout.Header css={cssLayoutHeader}>
      <div css={cssLayoutHeaderLeft}>
        <Link css={cssLink} reloadDocument to="/" title={"进入工作台"}>
          <img css={cssLogo} alt="logo" src={favicon} />
          软件逻辑地图
        </Link>
        <Divider type="vertical" css={cssDivider} />
        <span style={{ fontSize: 14, fontWeight: "bold" }}>流程看板</span>
      </div>

      <div css={cssLayoutHeaderCenter}>
        <span title={current.name} className="header_uvname" style={{ fontSize: 18}}>
          {current.bfName && `【${current.bfName}】`}{current.name}
        </span>
      </div>

      <div css={cssLayoutHeaderRight}>
        <Menu
          style={{ width: "inherit", flexGrow: 1, justifyContent: "flex-end" }}
          theme="dark"
          onClick={handleMenuClick}
          selectedKeys={[current.id]}
          mode="horizontal"
          items={items}
        />
      </div>
    </Layout.Header>
  );
};

export default Header;